/// <amd-module name="Feed/Legacy/Components/LabelWithExternalLink" />
import * as React from "react";

import { Label } from "OfficeFabric/Label";

import { IVssPageContext } from "VSS/Platform/Context";
import * as Utils_String from "VSS/Core/Util/String";

import { ExternalLink } from "Feed/Legacy/Components/ExternalLink";

export interface ILabelWithExternalLinkProps {
    pageContext: IVssPageContext;
    labelText: string;
    linkText: string;
    href: string;
    ciContext: string;
}

export class LabelWithExternalLink extends React.PureComponent<ILabelWithExternalLinkProps> {
    public render(): JSX.Element {
        return (
            <div className={"external-link-label-container"}>
                <Label className={"external-link-label"}>{this.props.labelText}</Label>
                <ExternalLink
                    className={"external-link"}
                    pageContext={this.props.pageContext}
                    href={this.props.href}
                    ciContext={this.props.ciContext}
                    linkAriaLabel={Utils_String.format("{0} {1}", this.props.labelText, this.props.linkText)}
                >
                    {this.props.linkText}
                </ExternalLink>
            </div>
        );
    }
}
